<div
  *ngIf="sortOptions$ | async as options"
  class="flight-item-sort pr-small-t font-body-1 regular-type flex flex--center"
>
  <div class="sort-label flex--nogrow">{{ 'ticketSelection.sort.title' | finLocalization }}:</div>
  <div class="sort-options flex-1 align-right">
    <div class="sort-options-list nordic-blue-900-text">
      <ng-container *ngFor="let option of options; let i = index">
        <input
          class="is-vishidden"
          name="selectedSortBy"
          type="radio"
          [attr.id]="'sort-by-input-' + i"
          [ngModel]="selectedSortBy$ | async"
          [value]="option.value"
          (ngModelChange)="sortByChange.emit($event)"
        />
        <label
          class="sort-option mr-small-l link-hover"
          [attr.for]="'sort-by-input-' + i"
          [class.selected-item]="option.value === (selectedSortBy$ | async)"
        >
          {{ option.label }}
        </label>
      </ng-container>
    </div>

    <select
      class="sort-options-select nordic-blue-900-text medium-type focus-inset"
      name="selectedSortBy"
      [ngModel]="selectedSortBy$ | async"
      (ngModelChange)="sortByChange.emit($event)"
    >
      <option *ngFor="let option of options" [value]="option.value">{{ option.label }}</option>
    </select>
  </div>
</div>
